module.exports = {"433101002":"峒河街道","433101004":"乾州街道","433101005":"镇溪街道","433101007":"石家冲街道","433101008":"双塘街道","433101100":"矮寨镇","433101101":"马颈坳镇","433101102":"河溪镇","433101104":"丹青镇","433101105":"太平镇","433101201":"已略乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433101.json
// module id = 1766
// module chunks = 0